import { Progress, Toast } from "antd-mobile";
import { get } from "lodash";
import PubSub from "pubsub-js";
import { language } from "@/utils/language";
const hasChild = {
  matrix_radio: true,
  matrix_checkbox: true,
  matrix_input: true,
};
/**
 * @name:
 * @test: test font
 * @msg:  xeb 答案数据一个的和多题不一致，导致分开处理
 * @param {*}
 * @return {*}
 */
export const checkAnswer = (Answer, _questionList) => {
  console.log(Answer, _questionList);
  if (_questionList.length === 1) {
    return checkAnswerSingle(Answer, _questionList);
  } else {
    return checkAnswerLenMore(Answer, _questionList);
  }
};
/**
 *@name: 重新组合答案
 * @param 原数据、
 * @return {*} 新答案数据
 */
export const formatAnswer = (questions, answers) => {
  let tempAnswer2 = [];
  questions.forEach((item, index) => {
    if (hasChild[item.model]) {
      if (get(answers, `[${index}][${item.id}]`, false)) {
        tempAnswer2.push({
          answers: { ...answers[index][item.id] },
          questionId: item.id,
        });
      } else {
        tempAnswer2 = [...tempAnswer2, { answers: {}, questionId: item.id }];
      }
    } else {
      if (item.childs?.length) {
        tempAnswer2 = [
          ...tempAnswer2,
          {
            answers: { ...(answers[index]?.[item.id] || {}) },
            questionId: item.id,
          },
        ];
      } else {
        tempAnswer2 = [
          ...tempAnswer2,
          { answers: { ...answers[index] }, questionId: item.id },
        ];
      }
    }
  });
  return tempAnswer2;
};
/**
 * @msg: 单题目校验
 * @param {*} Answer
 * @param {*} _questionList
 * @return {*}
 */
function checkAnswerSingle(Answer, _questionList) {
  const item = _questionList[0];
  const _answer = Answer[0];
  const {
    childPrefer: { optionForm },
  } = item.preferences;

  let isbreak = false;
  let noAnswerOption = {};
  if (item.model === "explain" || !item.required) {
    return [false, noAnswerOption];
  }
  if (Object.keys(_answer.answers).length === 0) {
    PubSub.publish("Modalalert",language().toast_msg + item.code);
    noAnswerOption = item;
    isbreak = true;
    return [isbreak, noAnswerOption];
  }
  if (item.model === "base_input") {
    const _itemOption = item.options.filter((item) => item.inputRequired);

    for (let index3 = 0; index3 < _itemOption.length; index3++) {
      const element = _itemOption[index3];
      if (!Object.keys(_answer.answers[item.id]).includes(element.id)) {
        PubSub.publish("Modalalert",language().toast_msg + item.code);
        noAnswerOption = item;
        isbreak = true;
      }
    }
    // if (Object.keys(_answer.answers[item.id]).length !== item.options.length) {
    //   PubSub.publish("Modalalert",language().toast_msg + item.code);
    //   noAnswerOption = item;
    //   isbreak = true;
    // }
  } else if (item.model === "matrix_radio") {
    let itemChilds = item.childs || [];
    itemChilds = itemChilds.filter((item) => {
      return item.moduleOption == 0 && item.required !== 0;
    });
    for (let index = 0; index < itemChilds.length; index++) {
      const element = itemChilds[index];
      let openInput = element.options
        .filter((item) => item.open == 2)
        .map((item) => item.id);
      const id = _answer.answers[element.id] || "";
      let isopenInput = true;

      for (const [key, value] of Object.entries(id)) {
        if (openInput.includes(key) && !value) {
          PubSub.publish("Modalalert",language().toast_msg + element.code);
          noAnswerOption = element;
          isbreak = true;
          isopenInput = false;
          publishData(optionForm, index);
        }
      }
      if (!isopenInput) break;
      if (!id) {
        let msg = element.description.replace(/<p>/g, "").replace(/<\/p>/g, "");
        PubSub.publish("Modalalert",language().toast_msg + msg);
        noAnswerOption = element;
        isbreak = true;
        publishData(optionForm, index);
        break;
      }
      // if (Object.keys(id).length === 0) {
      //   // publishData(optionForm, index);
      //   console.log(index);
      //   PubSub.publish("Modalalert","请回1111111答问题" + item.code);
      //   noAnswerOption = item;
      //   isbreak = true;
      //   break;
      // }
    }
  } else if (item.model == "matrix_input") {
    let itemChilds = item.childs || [];
    itemChilds = itemChilds.filter((item) => {
      return item.moduleOption == 0 && item.required !== 0;
    });
    for (let index = 0; index < itemChilds.length; index++) {
      const element = itemChilds[index];
      const id = _answer.answers[element.id] || {};
      if (Object.keys(id).length !== element.options.length) {
        publishData(optionForm, index);
        PubSub.publish("Modalalert",
          language().toast_msg +
            element.description.replace(/<p>/g, "").replace(/<\/p>/g, "")
        );
        noAnswerOption = element;
        isbreak = true;
        break;
      }
    }
  } else if (item.model == "matrix_checkbox") {
    let itemChilds = item.childs || [];
    itemChilds = itemChilds.filter((item) => {
      return item.moduleOption == 0;
    });
    for (let index = 0; index < itemChilds.length; index++) {
      const element = itemChilds[index];
      const id = _answer.answers[element.id] || {};

      let isopenInput = true;

      let openInput = element.options
        .filter((item) => item.open == 2)
        .map((item) => item.id);
      for (const [key, value] of Object.entries(id)) {
        if (openInput.includes(key)) {
          if (value) {
            break;
          } else {
            PubSub.publish("Modalalert",language().toast_msg + element.code);
            noAnswerOption = element;
            isbreak = true;
            isopenInput = false;
            publishData(optionForm, index);
            break;
          }
        }
      }
      if (!isopenInput) break;

      if (Object.keys(id).length === 0) {
        publishData(optionForm, index);
        console.log(element);
        PubSub.publish("Modalalert",
          language().toast_msg +
            element.description.replace(/<p>/g, "").replace(/<\/p>/g, "")
        );
        noAnswerOption = element;
        isbreak = true;
        break;
      }
    }
  }
  return [isbreak, noAnswerOption];
}

function publishData(optionForm, index) {
  if (optionForm == 4) {
    PubSub.publish("noAnswer", index);
  }
}
function checkAnswerLenMore(Answer, _questionList) {
  // 答案  和 list 是对应的
  let isbreak = false;
  let noAnswerOption = {};
  console.log(Answer, _questionList);
  for (let index = 0; index < _questionList.length; index++) {
    if (isbreak) break;
    let item = _questionList[index];
    if (item.model === "explain") {
      continue;
    }
    let findAnswerResult = Answer.find((item2) => {
      return item2.questionId === item.id;
    });
    let getLenData = Object.keys(findAnswerResult.answers);
    if (!findAnswerResult) {
      PubSub.publish("Modalalert",language().toast_msg + item.code);
      noAnswerOption = item;
      isbreak = true;
      PubSub.publish("Modalalert","这个题目没有作答");
      break;
    }
    if (getLenData.length === 0) {
      PubSub.publish("Modalalert",language().toast_msg + item.code);
      noAnswerOption = item;
      isbreak = true;
      break;
    }

    if (item.model === "matrix_radio") {
      for (let index2 = 0; index2 < item.childs.length; index2++) {
        const element = item.childs[index2];
        const singleA = findAnswerResult.answers[element.id];
        if (!singleA) {
          PubSub.publish("Modalalert",language().toast_msg + element.code);
          noAnswerOption = element;
          isbreak = true;
          break;
        } else {
          const asw3 = Object.keys(singleA);
          for (let index3 = 0; index3 < asw3.length; index3++) {
            const element3 = asw3[index3];
            const findAws1 = element.options.find((item) => {
              return item.id === element3;
            });
            console.log("singleA", singleA);
            if (!!findAws1.open && !singleA[element3]) {
              noAnswerOption = item;
              isbreak = true;
              PubSub.publish("Modalalert",language().toast_msg + element.code);
              break;
            }
          }
          if (isbreak) break;
        }
      }
    } else if (item.model === "matrix_input") {
      for (let index2 = 0; index2 < item.childs.length; index2++) {
        const element = item.childs[index2];
        const singleA = findAnswerResult.answers[element.id];
        if (!singleA) {
          PubSub.publish("Modalalert",language().toast_msg + element.code);
          noAnswerOption = item;
          isbreak = true;
          break;
        } else {
          for (let index4 = 0; index4 < element.options.length; index4++) {
            const element4 = element.options[index4];
            if (!Object.keys(singleA).includes(element4.id)) {
              PubSub.publish("Modalalert",language().toast_msg + element4.code);
              noAnswerOption = item;
              isbreak = true;
              break;
            }
          }
          if (isbreak) break;
        }
      }
    } else if (item.model === "base_radio") {
      const singleA = findAnswerResult.answers[item.id];
      if (!singleA) {
        PubSub.publish("Modalalert",language().toast_msg + item.code);
        noAnswerOption = item;
        isbreak = true;
        break;
      } else {
        if (!Object.keys(singleA)) {
          PubSub.publish("Modalalert",language().toast_msg + item.code);
          noAnswerOption = item;
          isbreak = true;
          break;
        }
      }
    } else if (item.model === "base_input") {
      const as2 = item.options.filter((item) => item.hide !== 1);
      for (let index2 = 0; index2 < as2.length; index2++) {
        const element = as2[index2];
        const singleA = findAnswerResult.answers[item.id];
        if (!singleA) {
          PubSub.publish("Modalalert",language().toast_msg + element.code);
          noAnswerOption = item;
          isbreak = true;
          break;
        } else {
          if (!Object.keys(singleA).includes(element.id)) {
            PubSub.publish("Modalalert",language().toast_msg + element.code);
            noAnswerOption = item;
            isbreak = true;
            break;
          }
          if (isbreak) break;
        }
      }
    } else if (item.model === "base_checkbox") {
      const as2 = item.options.filter((item) => item.hide !== 1);
      for (let index2 = 0; index2 < as2.length; index2++) {
        const element = as2[index2];
        const singleA = findAnswerResult.answers[item.id];
        if (!singleA) {
          PubSub.publish("Modalalert",language().toast_msg + element.code);
          noAnswerOption = item;
          isbreak = true;
          break;
        }
      }
    } else if (item.model === "dropdown_radio") {
      const as2 = item.options.filter((item) => item.hide !== 1);
      for (let index2 = 0; index2 < as2.length; index2++) {
        const element = as2[index2];
        const singleA = findAnswerResult.answers[item.id];
        if (!singleA) {
          PubSub.publish("Modalalert",language().toast_msg + element.code);
          noAnswerOption = item;
          isbreak = true;
          break;
        } else {
          // if (!Object.keys(singleA).includes(element.id)) {
          //   PubSub.publish("Modalalert",language().toast_msg + element.code);
          //   noAnswerOption = item;
          //   isbreak = true;
          //   break;
          // }
          // if (isbreak) break;
        }
      }
    } else if (item.model === "matrix_checkbox") {
      for (let index2 = 0; index2 < item.childs.length; index2++) {
        const element = item.childs[index2];
        const singleA = findAnswerResult.answers[element.id];
        if (!singleA) {
          PubSub.publish("Modalalert",language().toast_msg + element.code);
          noAnswerOption = item;
          isbreak = true;
          break;
        } else {
          const asw3 = Object.keys(singleA);
          if (asw3.length < 0) {
            PubSub.publish("Modalalert",language().toast_msg + element.code);
            noAnswerOption = item;
            isbreak = true;
            break;
          }
          if (isbreak) break;
        }
      }
    }
  }
  return [isbreak, noAnswerOption];
}
